import _objectSpread from "/data/landun/workspace/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "/data/landun/workspace/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.json.stringify.js";
import "regenerator-runtime/runtime.js";
import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-397a83ab"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "flex-v-center mb20"
};
var _hoisted_2 = {
  key: 0,
  style: {
    "padding": "10px 20px"
  }
};
var _hoisted_3 = {
  class: "mt20 mb20 flex0"
};

var _hoisted_4 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "w100 mt5"
  }, "授权数据：", -1);
});

var _hoisted_5 = {
  key: 0,
  class: "tree-box"
};

var _hoisted_6 = /*#__PURE__*/_createTextVNode("仅显示有权限的数据");

var _hoisted_7 = {
  class: "mb20 flex-v-center"
};

var _hoisted_8 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "w100"
  }, "授权类型：", -1);
});

var _hoisted_9 = {
  class: "mb20 flex-v-center"
};

var _hoisted_10 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "w100"
  }, "授权方式：", -1);
});

var _hoisted_11 = {
  class: "mb40 flex0"
};

var _hoisted_12 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "w100 mt10"
  }, "授权成员：", -1);
});

var _hoisted_13 = {
  class: "flex0"
};

var _hoisted_14 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "w100"
  }, null, -1);
});

var _hoisted_15 = /*#__PURE__*/_createTextVNode("提交");

var _hoisted_16 = {
  key: 1
};
import { unionBy, map, pick } from 'lodash';
import authWrap from './components/authWrap';
import authMember from './components/authMember';
import { useRoute } from 'vue-router';
import { ref, computed, watch, onMounted } from 'vue';
import { ElMessage } from 'element-plus';
import AuthService from '@/api/auth';
import DtMessage from '@/components/DtMessage';
import { asyncComputed } from '@vueuse/core';
import { getAuthListConfig } from './commons/authUtil';
export default /*#__PURE__*/_defineComponent({
  setup: function setup(__props) {
    var route = useRoute();
    var treeNodeRef = ref(null);
    var loading = ref(false);
    var showTree = ref(false);
    var dataList = ref([]);
    var defaultProps = ref({
      children: 'children',
      label: 'name'
    });
    var nodeInfos = ref([]);
    var dataTypes = ref([]);
    var authOption = ref({
      roleSelected: [],
      userSelected: [],
      groupSelected: [],
      selectedNames: []
    });
    var roleList = ref([]);
    var userList = ref([]);
    var grantModel = ref('MODIFY');
    var grantModelList = ref([{
      label: '修改',
      key: 'MODIFY',
      tips: '更改所选择的用户的资产权限范围，可缩小用户的权限范围'
    }, {
      label: '追加',
      key: 'ADD',
      tips: '不影响之前拥有的权限，添加授予更多的资产权限。（当有最高权限时以最高权限为准，且不修改有效期）'
    }]);
    var searchParams = ref({
      appKey: route.params.project || 'beacon_olap',
      bizId: route.params.biz_url,
      assetKey: '',
      assetQueryMode: 'ALL_WITH_PERM',
      keyword: '',
      pageNo: 1,
      pageSize: 1000
    });
    var onlyShowGrant = ref(false); // 具备GRANT权限的Action

    var canGrantAction = asyncComputed( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _res$data, _res$data2;

      var res;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return AuthService.queryCanGrantAction({
                appKey: searchParams.value.appKey,
                categoryKey: searchParams.value.assetKey
              });

            case 2:
              res = _context.sent;

              if (!(((_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.code) === 1)) {
                _context.next = 5;
                break;
              }

              return _context.abrupt("return", res.data.result);

            case 5:
              ElMessage({
                type: 'warning',
                message: (_res$data2 = res.data) === null || _res$data2 === void 0 ? void 0 : _res$data2.msg
              });
              return _context.abrupt("return", []);

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));
    var authTypeList = asyncComputed( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var typeList;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return getAuthListConfig({
                appKey: searchParams.value.appKey,
                categoryKey: searchParams.value.assetKey
              });

            case 2:
              typeList = _context2.sent;
              return _context2.abrupt("return", typeList.map(function (item) {
                return {
                  label: item.desc,
                  key: item.key,
                  value: false
                };
              }));

            case 4:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    })));

    var disabledTree = function disabledTree(list) {
      list.forEach(function (item) {
        var _item$current, _item$children;

        if (!canGrantAction.value.includes((_item$current = item.current) === null || _item$current === void 0 ? void 0 : _item$current.dataAssetAction)) {
          item.disabled = true;
        }

        if (((_item$children = item.children) === null || _item$children === void 0 ? void 0 : _item$children.length) > 0) {
          disabledTree(item.children);
        }
      });
    };

    var searchList = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var _dataTypes$value$find, _data$data;

        var data, result, list, _data$data2;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                dataList.value = [];
                nodeInfos.value = [];
                showTree.value = ((_dataTypes$value$find = dataTypes.value.find(function (item) {
                  return item.assetKey === searchParams.value.assetKey;
                })) === null || _dataTypes$value$find === void 0 ? void 0 : _dataTypes$value$find.resType) === 'TREE';
                searchParams.value.keyword = '';
                data = null;
                loading.value = true;

                if (!showTree.value) {
                  _context3.next = 12;
                  break;
                }

                _context3.next = 9;
                return AuthService.queryAssetTree(_objectSpread(_objectSpread({}, searchParams.value), {}, {
                  pageSize: 100000
                }));

              case 9:
                data = _context3.sent;
                _context3.next = 15;
                break;

              case 12:
                _context3.next = 14;
                return AuthService.queryAssetByPage(_objectSpread(_objectSpread({}, searchParams.value), {}, {
                  pageSize: 1000
                }));

              case 14:
                data = _context3.sent;

              case 15:
                loading.value = false;

                if (((_data$data = data.data) === null || _data$data === void 0 ? void 0 : _data$data.code) === 1) {
                  result = data.data.result;

                  if (showTree.value) {
                    dataList.value = result.children || [];
                    disabledTree(dataList.value);
                  } else {
                    list = [];
                    (result.itemList || []).forEach(function (item) {
                      if (canGrantAction.value.includes(item.dataAssetAction)) {
                        list.push({
                          name: "".concat(item.name, "(").concat(item.id, ")"),
                          primary: JSON.stringify(pick(item, ['id', 'name', 'objectId']))
                        });
                      }
                    });
                    dataList.value = list;
                  }
                } else {
                  if ((_data$data2 = data.data) !== null && _data$data2 !== void 0 && _data$data2.msg) {
                    DtMessage({
                      type: 'warning',
                      message: data.data.msg
                    });
                  }
                }

              case 17:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function searchList() {
        return _ref3.apply(this, arguments);
      };
    }();

    var updateAuthOption = function updateAuthOption(options) {
      authOption.value.userSelected = options.userSelected;
      authOption.value.roleSelected = options.roleSelected;
      authOption.value.groupSelected = options.groupSelected;
    };

    var getRole = /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var _data$data3;

        var _searchParams$value, bizId, appKey, data, result, userListTmp, roleListTmp;

        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _searchParams$value = searchParams.value, bizId = _searchParams$value.bizId, appKey = _searchParams$value.appKey;
                _context4.next = 3;
                return AuthService.getRoleList({
                  bizId: bizId,
                  appKey: appKey,
                  memberFlag: true
                });

              case 3:
                data = _context4.sent;

                if (((_data$data3 = data.data) === null || _data$data3 === void 0 ? void 0 : _data$data3.code) === 1) {
                  result = data.data.result || [];
                  userListTmp = [];
                  roleListTmp = [];
                  result.forEach(function (item) {
                    roleListTmp.push({
                      id: item.id,
                      name: item.name
                    });
                    userListTmp = userListTmp.concat(item.member_list);
                  });
                  roleList.value = roleListTmp;
                  userList.value = unionBy(userListTmp, 'login_name');
                }

              case 5:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      return function getRole() {
        return _ref4.apply(this, arguments);
      };
    }();

    var initData = /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var _data$data4;

        var data;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return AuthService.getListBaseInfoByAppkey({
                  appKey: searchParams.value.appKey
                });

              case 2:
                data = _context5.sent;

                if (((_data$data4 = data.data) === null || _data$data4 === void 0 ? void 0 : _data$data4.code) === 1) {
                  dataTypes.value = data.data.result;
                  searchParams.value.assetKey = dataTypes.value[0].assetKey;
                  searchList();
                  getRole();
                }

              case 4:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      return function initData() {
        return _ref5.apply(this, arguments);
      };
    }();

    var filterTree = function filterTree(list, newList, keyword) {
      list.forEach(function (item) {
        var _item$current2, _item$children2;

        if ((!onlyShowGrant.value || canGrantAction.value.includes((_item$current2 = item.current) === null || _item$current2 === void 0 ? void 0 : _item$current2.dataAssetAction)) && item.name.toLowerCase().includes(keyword)) {
          newList.push(item);
        } else if (((_item$children2 = item.children) === null || _item$children2 === void 0 ? void 0 : _item$children2.length) > 0) {
          filterTree(item.children, newList, keyword);
        }
      });
    };

    var setAuthAction = function setAuthAction(val, selectedIndex) {
      authTypeList.value.forEach(function (item, index) {
        if (val && index < selectedIndex || !val && index > selectedIndex) item.value = val;
      });
    };

    var grantSubmit = /*#__PURE__*/function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var _data$data5;

        var action, _authOption$value, roleSelected, userSelected, groupSelected, nodeInfosTmp, nodes, data, _data$data6;

        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                action = '';
                authTypeList.value.forEach(function (item) {
                  if (item.value) action = item.key;
                });

                if (!(action === '')) {
                  _context6.next = 5;
                  break;
                }

                ElMessage.error('请先选择授权类型');
                return _context6.abrupt("return");

              case 5:
                _authOption$value = authOption.value, roleSelected = _authOption$value.roleSelected, userSelected = _authOption$value.userSelected, groupSelected = _authOption$value.groupSelected;

                if (!(!roleSelected.length && !userSelected.length && !groupSelected.length)) {
                  _context6.next = 9;
                  break;
                }

                ElMessage.error('请先选择授权成员');
                return _context6.abrupt("return");

              case 9:
                nodeInfosTmp = [];

                if (showTree.value) {
                  nodes = treeNodeRef.value.getCheckedNodes();
                  nodes.forEach(function (item) {
                    nodeInfosTmp.push({
                      objectId: item.objectId,
                      name: item.name,
                      id: item.id
                    });
                  });
                } else {
                  nodeInfos.value.forEach(function (key) {
                    nodeInfosTmp.push(JSON.parse(key));
                  });
                }

                if (!(nodeInfosTmp.length === 0)) {
                  _context6.next = 14;
                  break;
                }

                ElMessage.error('请先选择授权数据');
                return _context6.abrupt("return");

              case 14:
                _context6.next = 16;
                return AuthService.grantAsset({
                  assetKey: searchParams.value.assetKey,
                  bizId: searchParams.value.bizId,
                  grantModel: grantModel.value,
                  nodeInfos: nodeInfosTmp,
                  action: action,
                  roleIds: roleSelected,
                  userIds: userSelected,
                  orgIds: map(groupSelected, 'orgId')
                });

              case 16:
                data = _context6.sent;

                if (((_data$data5 = data.data) === null || _data$data5 === void 0 ? void 0 : _data$data5.code) === 1) {
                  DtMessage({
                    type: 'success',
                    message: '操作成功'
                  });
                } else {
                  DtMessage({
                    type: 'warning',
                    message: (_data$data6 = data.data) === null || _data$data6 === void 0 ? void 0 : _data$data6.msg
                  });
                }

              case 18:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));

      return function grantSubmit() {
        return _ref6.apply(this, arguments);
      };
    }();

    var remoteMethod = /*#__PURE__*/function () {
      var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(keyword) {
        var _data$data7;

        var data, result, list;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return AuthService.queryAssetByPage(_objectSpread(_objectSpread({}, searchParams.value), {}, {
                  keyword: keyword
                }));

              case 2:
                data = _context7.sent;

                if (((_data$data7 = data.data) === null || _data$data7 === void 0 ? void 0 : _data$data7.code) === 1) {
                  result = data.data.result;
                  list = [];
                  (result.itemList || []).forEach(function (item) {
                    if (canGrantAction.value.includes(item.dataAssetAction)) {
                      list.push({
                        name: "".concat(item.name, "(").concat(item.id, ")"),
                        primary: JSON.stringify(pick(item, ['id', 'name', 'objectId']))
                      });
                    }
                  });
                  dataList.value = list;
                }

              case 4:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }));

      return function remoteMethod(_x) {
        return _ref7.apply(this, arguments);
      };
    }();

    var treeList = computed(function () {
      if (searchParams.value.keyword === '' && !onlyShowGrant.value) return dataList.value;
      var result = [];
      filterTree(dataList.value, result, searchParams.value.keyword.toLowerCase());
      return result;
    });
    watch([function () {
      return route.params.project;
    }, function () {
      return route.params.biz_url;
    }], function () {
      searchParams.value.appKey = route.params.project;
      searchParams.value.bizId = route.params.biz_url;
      initData();
    });
    onMounted(function () {
      initData();
    });
    return function (_ctx, _cache) {
      var _component_el_radio_button = _resolveComponent("el-radio-button");

      var _component_el_radio_group = _resolveComponent("el-radio-group");

      var _component_el_alert = _resolveComponent("el-alert");

      var _component_el_checkbox = _resolveComponent("el-checkbox");

      var _component_el_input = _resolveComponent("el-input");

      var _component_el_tree = _resolveComponent("el-tree");

      var _component_el_option = _resolveComponent("el-option");

      var _component_el_select = _resolveComponent("el-select");

      var _component_question_filled = _resolveComponent("question-filled");

      var _component_el_icon = _resolveComponent("el-icon");

      var _component_el_tooltip = _resolveComponent("el-tooltip");

      var _component_el_radio = _resolveComponent("el-radio");

      var _component_el_button = _resolveComponent("el-button");

      var _directive_loading = _resolveDirective("loading");

      return _openBlock(), _createBlock(_unref(authWrap), {
        "search-params": searchParams.value
      }, {
        default: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_radio_group, {
            modelValue: searchParams.value['assetKey'],
            "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
              return searchParams.value['assetKey'] = $event;
            }),
            onChange: _cache[1] || (_cache[1] = function ($event) {
              return searchList();
            })
          }, {
            default: _withCtx(function () {
              return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataTypes.value, function (item) {
                return _openBlock(), _createBlock(_component_el_radio_button, {
                  key: item['assetKey'],
                  label: item['assetKey']
                }, {
                  default: _withCtx(function () {
                    return [_createTextVNode(_toDisplayString(item['assetName']), 1)];
                  }),
                  _: 2
                }, 1032, ["label"]);
              }), 128))];
            }),
            _: 1
          }, 8, ["modelValue"])]), dataTypes.value.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_component_el_alert, {
            type: "info",
            "show-icon": "",
            title: "请注意：若其中有选择目录，则目录内历史存在和后续产生的所有子目录和数据资产，均将自动授权给该角色组/用户。"
          }), _createElementVNode("div", _hoisted_3, [_hoisted_4, showTree.value ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_5, [_createVNode(_component_el_checkbox, {
            class: "mb10",
            modelValue: onlyShowGrant.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
              return onlyShowGrant.value = $event;
            })
          }, {
            default: _withCtx(function () {
              return [_hoisted_6];
            }),
            _: 1
          }, 8, ["modelValue"]), _createVNode(_component_el_input, {
            class: "mb10",
            "prefix-icon": "search",
            placeholder: "输入关键字回车搜索",
            clearable: "",
            modelValue: searchParams.value.keyword,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) {
              return searchParams.value.keyword = $event;
            })
          }, null, 8, ["modelValue"]), _createVNode(_component_el_tree, {
            ref_key: "treeNodeRef",
            ref: treeNodeRef,
            data: _unref(treeList),
            props: defaultProps.value,
            "show-checkbox": "",
            "check-strictly": "",
            "node-key": "objectId"
          }, {
            default: _withCtx(function (_ref8) {
              var data = _ref8.data;
              return [_createElementVNode("span", {
                class: _normalizeClass(['node-name', {
                  disabled: data.disabled
                }])
              }, _toDisplayString(data.name) + "(" + _toDisplayString(data.id) + ")", 3)];
            }),
            _: 1
          }, 8, ["data", "props"])])), [[_directive_loading, loading.value]]) : (_openBlock(), _createBlock(_component_el_select, {
            key: 1,
            modelValue: nodeInfos.value,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = function ($event) {
              return nodeInfos.value = $event;
            }),
            class: "filling",
            multiple: "",
            filterable: "",
            remote: "",
            "reserve-keyword": "",
            placeholder: "请输入关键词",
            "remote-method": remoteMethod,
            loading: loading.value
          }, {
            default: _withCtx(function () {
              return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataList.value, function (item) {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: item.objectId,
                  label: item.name,
                  value: item.primary
                }, null, 8, ["label", "value"]);
              }), 128))];
            }),
            _: 1
          }, 8, ["modelValue", "loading"]))]), _createElementVNode("div", _hoisted_7, [_hoisted_8, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(authTypeList), function (item, index) {
            return _openBlock(), _createBlock(_component_el_checkbox, {
              modelValue: item.value,
              "onUpdate:modelValue": function onUpdateModelValue($event) {
                return item.value = $event;
              },
              onChange: function onChange($event) {
                return setAuthAction($event, index);
              },
              label: item.key,
              key: item.key
            }, {
              default: _withCtx(function () {
                return [_createTextVNode(_toDisplayString(item.label), 1)];
              }),
              _: 2
            }, 1032, ["modelValue", "onUpdate:modelValue", "onChange", "label"]);
          }), 128))]), _createElementVNode("div", _hoisted_9, [_hoisted_10, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(grantModelList.value, function (item) {
            return _openBlock(), _createBlock(_component_el_radio, {
              modelValue: grantModel.value,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = function ($event) {
                return grantModel.value = $event;
              }),
              label: item.key,
              key: item.key
            }, {
              default: _withCtx(function () {
                return [_createTextVNode(_toDisplayString(item.label) + " ", 1), (_openBlock(), _createBlock(_component_el_tooltip, {
                  key: item.key,
                  content: item.tips,
                  placement: "bottom"
                }, {
                  default: _withCtx(function () {
                    return [_createVNode(_component_el_icon, {
                      style: {
                        "margin-left": "5px"
                      }
                    }, {
                      default: _withCtx(function () {
                        return [_createVNode(_component_question_filled)];
                      }),
                      _: 1
                    })];
                  }),
                  _: 2
                }, 1032, ["content"]))];
              }),
              _: 2
            }, 1032, ["modelValue", "label"]);
          }), 128))]), _createElementVNode("div", _hoisted_11, [_hoisted_12, _createVNode(_unref(authMember), {
            class: "filling",
            "panel-width": 475,
            "user-key-value": ['login_name', 'name'],
            "role-list": roleList.value,
            "user-list": userList.value,
            "auth-option": authOption.value,
            onUpdateAuthOption: updateAuthOption
          }, null, 8, ["role-list", "user-list", "auth-option"])]), _createElementVNode("div", _hoisted_13, [_hoisted_14, _createVNode(_component_el_button, {
            type: "primary",
            onClick: grantSubmit
          }, {
            default: _withCtx(function () {
              return [_hoisted_15];
            }),
            _: 1
          })])])) : (_openBlock(), _createElementBlock("div", _hoisted_16, "暂不支持数据资产批量授权"))];
        }),
        _: 1
      }, 8, ["search-params"]);
    };
  }
});